import { PRODUCT_DATA, PRODUCT_ERROR_DATA, PRODUCT_HIDE_ERROR_DATA, PRODUCT_START_LOADER, PRODUCT_STOP_LOADER, } from "../interface/iProductDetails";
const initialState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const product = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCT_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case PRODUCT_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case PRODUCT_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case PRODUCT_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case PRODUCT_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default product;
